import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useEditAdditionalGroup, {
  EditAdditionalGroupProps,
} from 'modules/additional-groups/hooks/use-edit-additional-group';
import {translatedAdditionalGroupProps} from 'modules/additional-groups/types';
import additionalGroupsKeys from 'modules/additional-groups/util/additional-groups-keys';
import useCompaniesSelectData from 'modules/companies/hooks/use-companies-select-data';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditAdditionalGroup: React.FC = () => {
  const {id} = useParams();
  const {getInput, getSelect} = useFormInputs();
  const {data, isLoading} = useCompaniesSelectData();
  const {companyId} = useAccessControls();

  return (
    <Edition<EditAdditionalGroupProps>
      inputs={[
        getInput({
          name: 'description',
        }),
        getInput({name: 'name'}),
        getSelect({
          name: 'companyId',
          data,
          isLoading,
          hidden: () => !!companyId,
        }),
      ]}
      detailsUrl={`/additional-groups/${id}`}
      onSubmit={() => useEditAdditionalGroup(id!)}
      translationKey={translatedAdditionalGroupProps}
      queryKey={additionalGroupsKeys.details(id!)}
    />
  );
};

export default EditAdditionalGroup;
